import { GameData } from './types';
import { assetUrl } from './logic';

let cache: GameData | null = null;

export async function chargerDonnees(): Promise<GameData> {
  if (cache) return cache;
  const noms = ['config', 'personnages', 'questions', 'invites', 'motscles', 'bestof'];
  const [config, personnages, questions, invites, motscles, bestof] = await Promise.all(
    noms.map((n) => fetch(assetUrl(`data/${n}.json`)).then((r) => r.json()))
  );
  cache = { config, personnages, questions, invites, motscles, bestof };
  return cache;
}
